import React, { PureComponent } from "react";
import queryString from "query-string";

import Table from "antd/lib/table";
import Popover from "antd/lib/popover";
import Button from "antd/lib/button";
import Select from "antd/lib/select";
import Popconfirm from "antd/lib/popconfirm";
import Drawer from "antd/lib/drawer";

import find from "lodash/find";
import findIndex from "lodash/findIndex";

import {
  readLevels,
  moveWordToLevel,
  updateLevel,
  getAllData,
  readLists
} from "helpers/api";

import ImageUpload from "components/ImageUpload";

const Option = Select.Option;

const newWordData = {};

class Words extends PureComponent {
  state = {
    data: {},
    uneditedData: {},
    isLoading: false,
    sortedInfo: {
      order: "ascend",
      columnKey: "id"
    },
    isEdited: false,
    isDrawerVisible: false,
    lists: []
  };

  componentDidMount() {
    const { level } = this.getQueryValues();
    this.readData(level);
  }

  getQueryValues() {
    const { columns, level, move, replace } = queryString.parse(
      window.location.search
    );
    let currentColumns = [
      "id",
      "image",
      "de",
      "en",
      "type",
      "example_en",
      "category",
      "german_gender"
    ];
    let currentLevel = 1;
    let isMoveButtonVisible = false;
    let isReplaceVisible = false;
    if (columns) {
      currentColumns = columns.split(",");
    }
    if (level) {
      currentLevel = level;
    }
    if (move) {
      isMoveButtonVisible = move === "true";
    }
    if (replace) {
      isReplaceVisible = replace === "true";
    }
    return {
      columns: currentColumns,
      level: currentLevel,
      isMoveButtonVisible,
      isReplaceVisible
    };
  }

  componentDidUpdate() {}

  readData = async id => {
    this.setState({ isLoading: true, data: {} });
    const levelWords = await readLevels(id);
    const listsResponse = await readLists();
    this.setState({
      data: levelWords,
      isLoading: false,
      uneditedData: levelWords,
      isEdited: false,
      lists: listsResponse.data
    });
  };

  handleLevelChange = val => {
    const { columns } = this.getQueryValues();
    this.props.history.push(
      `/public?columns=${columns.join(",")}&level=${val}`
    );
    this.readData(val);
  };

  handleFieldEdit = (wordId, columnKey, newValue) => {};

  handleWordReplace = wordId => {};

  render() {
    const {
      data,
      isLoading,
      sortedInfo,
      isEdited,
      isDrawerVisible,
      lists
    } = this.state;
    if (!data) return null;
    const {
      columns: visibleColumns,
      level,
      isMoveButtonVisible,
      isReplaceVisible
    } = this.getQueryValues();

    const { id, words } = data;

    let columns = [];
    let dataSource = [];

    if (words) {
      columns = [
        "id",
        "image",
        "en",
        "example_en",
        "category",
        "german_gender",
        "type",
        "ar",
        "ar_pronunciation",
        "bg",
        "da",
        "es",
        "fi",
        "fr",
        "hi",
        "hi_pronunciation",
        "it",
        "ja",
        "ja_pronunciation",
        "ko",
        "ko_pronunciation",
        "nl",
        "no",
        "pl",
        "pt",
        "ro",
        "ru",
        "sv",
        "'zh-CN'",
        "'zh-CN_pronunciation'",
        "tr",
        "de",
        "de_plural"
      ].map(key => {
        if (key === "image") {
          return {
            title: key,
            render: record => {
              return (
                <ImageUpload
                  image={record.image}
                  disabled
                  onChange={imageURL => {
                    this.handleFieldEdit(record.id, "image", imageURL);
                  }}
                />
              );
            },
            key: key
          };
        } else if (key === "id") {
          return {
            title: key,
            dataIndex: key,
            key: key,
            sorter: (a, b) => a.id - b.id,
            sortOrder: sortedInfo.columnKey === "id" && sortedInfo.order
          };
        } else if (key === "german_gender") {
          return {
            title: key,
            key: key,
            render: record => {
              if (/der\s|die\s|das\s/i.test(record.de)) {
                const article = record.de.split(" ")[0].toLowerCase();
                return (
                  <span>
                    {article === "die"
                      ? "feminine"
                      : article === "der"
                      ? "masculine"
                      : "neuter"}
                  </span>
                );
              }
              return <span>-</span>;
            }
          };
        }
        return {
          title: key,
          key: key,
          render: record => <span>{record[key]}</span>
        };
      });

      dataSource = words.map(word => {
        let category;
        lists.forEach(list => {
          if (list.wordIDs.indexOf(word.id) !== -1) {
            category = list.name;
          }
        });
        return {
          key: word.id,
          category,
          ...word
        };
      });
    }

    const columnKeys = columns.map(column => (
      <Option id={column.key} key={column.key}>
        {column.key}
      </Option>
    ));

    const filteredColumns = columns.filter(
      column => visibleColumns.indexOf(column.key) !== -1
    );

    return (
      <div className="Words">
        <div>
          <span>Select Level: </span>
          <Select
            defaultValue={level}
            style={{ width: 120 }}
            onChange={this.handleLevelChange}
          >
            {new Array(70).fill(0).map((_, index) => (
              <Option key={index} value={index + 1}>
                {index + 1}
              </Option>
            ))}
          </Select>
        </div>
        <Table
          dataSource={dataSource}
          columns={[...filteredColumns]}
          pagination={false}
          scroll={{ x: 900 }}
          loading={isLoading}
        />
      </div>
    );
  }
}

export default Words;



// WEBPACK FOOTER //
// ./src/containers/Public/index.js